import { Box, Flex } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';

import {
  CohortCadence,
  PortfolioChartConfig,
  portfolioFormatterMap,
} from './portfolioChartUtils';
import { PortfolioGridItem } from './PortfolioGridItem';
import { Typography } from '~/packages/common-frontend/components/Typography';

type Datapoint = { cohortSeriesAge: number; [key: string]: Util.Primitive };
type PortfolioVintageChartCardsProps<T extends Datapoint> = {
  selectedDatapoint: T;
  chartConfig: PortfolioChartConfig<any>;
  cohortSeriesCadence: CohortCadence;
  activeFields: Partial<keyof T>[];
  onToggleActiveField: (selectedField: keyof T) => void;
};

export function PortfolioVintageChartCards<T extends Datapoint>({
  selectedDatapoint,
  chartConfig,
  cohortSeriesCadence,
  activeFields,
  onToggleActiveField,
}: PortfolioVintageChartCardsProps<T>) {
  const sortedConfigs = Object.values(chartConfig).sort((a, b) => {
    if (!a) {
      return 1;
    }
    if (!b) {
      return 1;
    }
    const aIsActive = _.includes(activeFields, a.field);
    const bIsActive = _.includes(activeFields, b.field);
    if (aIsActive && !bIsActive) {
      return -1;
    }
    if (!aIsActive && bIsActive) {
      return 1;
    }
    return a.field < b.field ? 1 : -1;
  });

  return (
    <Flex direction="column" gap="1rem" width="100%">
      <Typography fontWeight="semibold">
        Vintage:{' '}
        {`${selectedDatapoint.cohortSeriesAge} ${cohortSeriesCadence}s`}
      </Typography>
      <Box maxHeight="700px" overflowY="auto">
        {sortedConfigs.map((config) => {
          if (!config) {
            return null;
          }
          const value = selectedDatapoint[config.field];
          const { label, format } = config;
          const formattedValue = portfolioFormatterMap[format](value);
          const isActive = _.includes(activeFields, config.field);

          return (
            <Box
              key={config.field}
              onClick={() => onToggleActiveField(config.field)}
              mb="24px"
            >
              <PortfolioGridItem
                label={label}
                value={formattedValue}
                isActive={isActive}
                cursor="pointer"
              />
            </Box>
          );
        })}
      </Box>
    </Flex>
  );
}
